import { Typography } from "@mui/material";
import React from "react";

import { TicketStatusLabel, ChipTicketStatusColor } from "src/constants";
import { type TicketStatusEnum } from "src/graphql/generated/types";

type Props = {
  status: TicketStatusEnum;
};

export const ChipTicketStatus = ({ status }: Props) => {
  return (
    <Typography
      sx={(theme) => ({
        backgroundColor: ChipTicketStatusColor[status],
        color: theme.palette.tickets.statusText[status],
        fontWeight: "bold",
        borderRadius: 1,
        px: 2,
        py: 0.5,
      })}
      data-testid="ticketStatus"
    >
      {TicketStatusLabel[status]}
    </Typography>
  );
};
